module.exports = __webpack_public_path__ + "img/made_in_France_couleur.a2ca5a7.svg";